/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-09-13 16:58:58
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-03-22 10:18:28
 */
import request from '@/utils/request'
import type * as memo from '@/typings/memo'


interface IGetBusyParticipantsRequest {
  end_time?:          number
  exclude_meeting_id?: number
  start_time?:        number
  uids?:             number[]
}
// 工作台 - 会议 - 获取忙碌的参会人
export async function getBusyParticipants(params: IGetBusyParticipantsRequest) {
  return request('/api/v2/file/meeting_busy_participant_list', {
    method: 'GET',
    data: params
  })
}


interface ICreateMeetingMinutesRequest {
  mm: memo.IMeetingMinuteRequest
}
// Memo-新增会议纪要
export async function createMeetingMinutes(params: ICreateMeetingMinutesRequest) {
  return request('/api/v2/file/meeting_minute_create', {
    method: 'post',
    data: params
  })
}

interface IUpdateMeetingMinutesRequest {
  mm: memo.IMeetingMinuteRequest
}
// Memo-编辑会议纪要
export async function updateMeetingMinutes(params: IUpdateMeetingMinutesRequest) {
  return request('/api/v2/file/meeting_minute_update', {
    method: 'post',
    data: params
  })
}

interface IDeleteMeetingMinutesRequest {
  id: number
  from: number
}
// Memo-删除会议纪要
export async function deleteMeetingMinutes(params: IDeleteMeetingMinutesRequest) {
  return request('/api/v2/file/meeting_minute_delete', {
    method: 'post',
    data: params
  })
}
